<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th>Charge</th>
          <th>Rate</th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        <rates
          :tariff="tariff"
          :rates="ratesForm.rates"
          :is-group="tariff.isGroup"
          :key="`item-${tariffIndex}`"
          :readonly="readonly"
          v-for="(tariff, tariffIndex) in tariffs"
        ></rates>
        <tr>
          <td>Storage Daily Rate</td>
          <td>
            <currency-input
              name="storage_daily_rate"
              v-model="ratesForm.storage_daily_rate"
              :readonly="readonly"
            ></currency-input>
          </td>
          <td>N/A</td>
        </tr>
        <tr>
          <td>Storage Cap</td>
          <td>
            <currency-input
              name="storage_cap"
              v-model="ratesForm.storage_cap"
              :readonly="readonly"
            ></currency-input>
          </td>
          <td>N/A</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Rates from '@/components/Modules/Shared/Tariff/Rates.vue';
import CurrencyInput from '@/components/Generic/Form/CurrencyInput.vue';

export default {
  props: {
    ratesForm: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    CurrencyInput,
    Rates
  },

  computed: {
    tariffs() {
      const charges = this.$store.getters['CreditHireCharges/all']
        .filter(charge => charge.name !== 'daily')
        .map(charge => ({ ...charge, isGroup: false }));

      const groups = this.$store.getters['VehicleGroups/all']
        .filter(group => group.name.startsWith('B'))
        .map(group => ({ ...group, isGroup: true }));

      return [...groups, ...charges];
    }
  }
};
</script>
